<template>
  <form @submit.prevent="submit" class="sale-card-machine-form">
    <form-group
      id="code"
      label="Código"
      v-model="form.code"
      placeholder="XXXXXX"
      :errors="errors.code"
    />
    <form-group
      id="name"
      label="Nome do cliente"
      v-model="form.name"
      placeholder="Ex.: Jhon Doe"
      :errors="errors.name"
    />
    <form-group
      id="email"
      label="E-mail do cliente"
      v-model="form.email"
      placeholder="Ex.: nGfJt@example.com"
      :errors="errors.email"
    />
    <form-group
      id="phone"
      label="Telefone do cliente"
      v-model="form.phone"
      placeholder="Ex.: (99) 99999-9999"
      :errors="errors.phone"
    />
    <form-group
      id="document"
      label="Documento do cliente"
      v-model="form.document"
      placeholder="Ex.: 999.999.999-99"
      :errors="errors.document"
    />

    <div class="card my-5" v-if="sale && sale.id">
      <div class="card-body">
        <div><strong>Produto</strong>: {{ sale.product.name }}</div>
        <div v-if="sale.offer">
          <strong>Oferta</strong>: {{ sale.offer.name }}
        </div>
        <div v-if="sale.plan"><strong>Plano</strong>: {{ sale.plan.name }}</div>
      </div>
    </div>

    <template v-else>
      <action-dispatcher action="product/get">
        <form-group
          slim
          select
          v-model="form.product_id"
          id="product-select"
          label="Produto"
          placeholder="Selecione o produto"
          :options="productOptions"
        />
      </action-dispatcher>

      <div v-if="form.product_id" :key="form.product_id">
        <action-dispatcher
          v-if="isSignature"
          action="plan/get"
          :parameters="{ product_id: form.product_id, limit: 1000 }"
        >
          <form-group
            slim
            select
            id="plan-select"
            label="Plano"
            v-model="form.plan_id"
            placeholder="Selecione o plano"
            :options="plans"
            :errors="errors.plan_id"
          />
        </action-dispatcher>
        <action-dispatcher
          v-else
          action="offer/get"
          :parameters="{ product_id: form.product_id, limit: 1000 }"
        >
          <form-group
            slim
            select
            id="offer-select"
            label="Oferta"
            v-model="form.offer_id"
            placeholder="Selecione a oferta"
            :options="offers"
            :errors="errors.offer_id"
          />
        </action-dispatcher>
      </div>
    </template>

    <form-group
      slim
      select
      id="status-select"
      label="Status"
      v-model="form.status"
      placeholder="Selecione a status"
      :options="statuses"
      :errors="errors.status"
      :disabled="disableEditStatus"
    />

    <div class="row mt-5">
      <div class="col-lg-6">
        <button
          type="button"
          class="btn btn-outline-secondary w-100"
          @click="$emit('close')"
        >
          Cancelar
        </button>
      </div>
      <div class="col-lg-6">
        <button type="submit" class="btn btn-primary w-100">
          <loading :show="loading">
            Salvar
          </loading>
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import { formFields } from "@/functions/helpers";
import { mapState } from "vuex";

export const statuses = [
  { id: "approved", name: "Aprovado", class: "success" },
  { id: "reconciled", name: "Conciliado", class: "info" },
  { id: "canceled", name: "Cancelado", class: "danger" }
];

export default {
  props: {
    sale: Object
  },
  data() {
    const sale = this.sale || {};
    return {
      statuses,
      loading: false,
      ...formFields(
        [
          "code",
          "name",
          "email",
          "phone",
          "document",
          "product_id",
          "offer_id",
          "plan_id",
          "status"
        ],
        {
          ...sale,
          status: sale.status || "approved"
        }
      )
    };
  },
  computed: {
    ...mapState("product", ["products"]),
    ...mapState("offer", ["offers"]),
    ...mapState("plan", ["plans"]),
    disableEditStatus() {
      return this.sale?.id && this.form.status === "reconciled";
    },
    productOptions() {
      return [...this.products.filter(p => p.status == "active")];
    },
    isSignature() {
      return (
        this.products.find(p => p.id === this.form.product_id).type_product ===
        "signature"
      );
    }
  },
  methods: {
    submit() {
      const data = { ...this.form };

      if (this.sale?.id) {
        data.id = this.sale.id;
      } else {
        if (!data.product_id) {
          this.$message.error("Selecione um produto");
          return;
        }
      }

      const action = this.sale?.id
        ? "cardMachine/putSale"
        : "cardMachine/postSale";

      this.loading = true;
      this.$store
        .dispatch(action, data)
        .then(() => {
          this.$message.success("Salvo com sucesso");
          this.$emit("close");
          this.$emit("refresh");
        })
        .catch(error => {
          this.errors = error.response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
